import "../../../assets/scss/pages/cugate.scss";
import images from '../../../assets/images/cugate';
import { SplashPage } from "../../../components/splash";
import React, { useEffect, useState, useRef } from "react";
import { tabList, menuList, featureList, officeList } from "./contents";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
export const CugatePage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('');
  const [activeItem, setActiveItem] = useState(0);
  const [scrollPosition, setScrollPosition] = useState(0);
  const isMounted = useRef(true);
  const [readMoreAbout, setReadMoreAbout] = useState(false);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [headerHeight, setHeaderHeight] = useState(100);

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
    let current_pos = 0;
    menuList.forEach((value, index) => {
      const element = document.getElementById(value.href);
      if (element) {
        const top = element.offsetTop;
        if (position > top - headerHeight) {
          current_pos = index
        }
      }
    });
    setActiveItem(current_pos);
  };

  const handleResize = () => {
    const headerElement = document.getElementById("header-menu");
    if (headerElement) {
      setHeaderHeight(headerElement.clientHeight);
    }
  }

  const handleLoading = () => {
    setIsLoading(false);
  }
  const handleClickMenuItem = (index: number) => {
    setActiveItem(index);
    if (index < menuList.length) {
      const elementID = menuList[index].href;
      const element = document.getElementById(elementID);
      const currentHeight = window.pageYOffset;
      if (element) {
        const top = element.offsetTop;
        const delta = 20;
        if (currentHeight < headerHeight && top > headerHeight) {
          window.scrollTo({ top: top - headerHeight * 2 + delta, behavior: 'smooth' });
        }
        else {
          window.scrollTo({ top: top - headerHeight + delta, behavior: 'smooth' });
        }
      }
    }
  }
  const signup = () => {
    navigate('/register');
  };
  useEffect(() => {
    window.addEventListener("load", handleLoading);
    if (isMounted.current) {
      setIsLoading(false);
    }
    return () => {
      isMounted.current = false;
      window.removeEventListener("load", handleLoading);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  return isLoading ? (
    <SplashPage />
  ) : (
    <div className={"page page-cugate"}>
      {/* <section className={"menu-uk-section -uk-section uk-section-default uk-visible@l " + (scrollPosition > 80 ? "uk-sticky" : "")}>
        <div className="uk-container uk-container-large">
          <div className="cg-menu">
            <ul className="uk-grid uk-grid-small uk-flex-between" id="header-menu">
              {
                menuList?.map((value, index) => (
                  <li className={activeItem === index ? "uk-first-column uk-active" : ""} key={index}>
                    <Link
                      to={"#" + value.href}
                      onClick={(e) => {handleClickMenuItem(index)}}
                      className="uk-link-reset uk-margin-medium-top uk-margin-medium-bottom uk-display-inline-block"
                    >
                      <span className="uk-text-bold uk-text-secondary uk-text-uppercase">
                        {
                          //scrollPosition+'/'+sectionTop[index].top?.toFixed(0)
                        }
                        {
                          value.text
                        }
                      </span>
                    </Link>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </section> */}

      {/*About Us*/}
      <section id="about-us" className="uk-section uk-section-default">
        <div className="uk-container uk-container-large">
          <div className="uk-grid uk-grid-large uk-flex-middle">
            <motion.div className="uk-width-1-3@m " animate={{ opacity: 1, }}>
              <div className="uk-panel" uk-scrollspy="target: > *; cls: uk-animation-slide-right-medium; delay: 300">
                <motion.img
                  alt=""
                  src="/imgs/landing/logo-cugate-ag.svg"
                  className="uk-heading-medium uk-text-primary cugate-logo-text"
                  initial="hidden"
                  whileInView="visible"
                  transition={{ duration: 1 }}
                  variants={{ hidden: { x: -100, y: 0 }, visible: { x: 0, y: 0 }, }}
                />
                {
                  !activeTab && (
                    <motion.p className="uk-margin-medium uk-text-large log-sub-text"
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1, delay: 0.3 }}
                      variants={{ hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 }, }}
                    >
                      Cugate AG is a German big data company that was founded by music producer and manager Hanspeter ”Memo” Rhein.
                    </motion.p>
                  )
                }
              </div>
            </motion.div>
            <div className="uk-width-2-3@m uk-first-column">
              {
                !activeTab && (
                  <div className="uk-position-relative">
                    <motion.img alt="" src="/imgs/landing/face-4.png" className="uk-position-cover"
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { opacity: 0, x: -100, y: 0 }, visible: { opacity: 1, x: 0, y: 0 } }}
                    />
                    <motion.img alt="" src="/imgs/landing/face-3.png" className="uk-position-cover"
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { opacity: 0, x: -100 }, visible: { opacity: 1, x: 0 }, }}
                    />
                    <motion.img alt="" src="/imgs/landing/face-2.png" className="uk-position-cover"
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { scale: 3 }, visible: { scale: 1 }, }}
                    />
                    <motion.img alt="" src="/imgs/landing/face-1.png"
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { opacity: 0, x: 0, y: -100 }, visible: { opacity: 1, x: 0, y: 0 } }}
                    />
                  </div>
                )
              }
            </div>


          </div>
        </div>
      </section>

      {/* Tab list */}
      <section className="uk-section uk-section-default tab-list">
        <div className="uk-container uk-container-large">
          <ul className={"tab-nav"} style={!activeTab ? {marginBottom: '140px'} : {}}>
            {tabList?.map((tab, index) => (
              <li
                key={index}
                className={`nav-item ${(tab.key === activeTab ? 'active' : '')}`}
                onClick={() => setActiveTab(tab.key)}
              >
                <Link to={""}>{tab.text}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="content-wrapper tab-content">
          {activeTab === tabList[0].key ? (
            <div className="tab-item technology-tab">
              <div className="uk-container uk-container-large">
                <div className="uk-light uk-padding-large uk-padding-remove-horizontal">
                  <div className="uk-grid uk-grid-large uk-child-width-1-2@m">
                    <div className="uk-first-column">
                      <div className="uk-position-relative">
                        <motion.img alt="" src="/imgs/landing/technology-4.png"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, scale: 1.5 }, visible: { opacity: 1, scale: 1 }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/technology-3.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1, delay: 0.6 }}
                          variants={{ hidden: { opacity: 0, }, visible: { opacity: 1, }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/technology-2.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/technology-1.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, x: -100 }, visible: { opacity: 1, x: 0 }, }}
                        />
                      </div>
                    </div>

                    <motion.div className=""
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 }, }}
                    >
                      <div className="uk-panel">
                        <h1 className="uk-heading-medium uk-text-primary tab-title">
                          Technology
                        </h1>
                        <p className="uk-margin-medium">
                          Our primary goal is to support the general change in the media business from haptic to virtual sales and business processes,
                          to secure business areas with a worldwide patented solution <strong> CUGATE's VIRTUAL BARCODE </strong>
                          (our global, unique non-intrusive media operating & management development) to make the newly created point of sales and monetary structures & solutions manageable, as well as to implement these goals in a virtual, global and unrestricted marketplace.
                        </p>
                        <p>
                          Our unique (MOS) (Media Operating System) solution helps to secure new business areas and to make the point of sales and monetary structures & solutions manageable and usable. We are already successfully implementing this approach in several pilot projects.
                        </p>
                        <p>
                          We have been developing and optimizing our worldwide patented fingerprinting and watermarking technology for almost 20 years. There are already proven and scalable solutions for radio and TV monitoring with an associated calculation of the license fees to be paid in real time, an AI-supported system for the sync and license area and third-party advertisement solutions for TV and video sales. Further application systems are under development.
                        </p>
                        <p>
                          Musicians, scientists, producers, artists and music publishers around the world have contributed to the creation of the CUGATE solutions. The result is a solution tailored to all sales and marketing processes in the film and music industry. In recent years, Memo Rhein has been able to put together an excellent team which is unparalleled in terms of experience and expertise, with offices in Berlin, the USA, Georgia and China.
                        </p>
                      </div>
                    </motion.div>

                    <div className="uk-panel">
                      <h2 className="uk-h1 uk-text-primary">
                        Footprint
                      </h2>
                      <div className="uk-text-small">
                        <p>
                          Cugate AG is the first company to hold two global patents for fingerprint and watermark technologies developed in-house. We combine these two systems in our “Virtual Barcode” product, the central component of all our solutions. All the music we distribute is fingerprinted and watermarked so that every copyright and distribution data point is stored on all possible platforms.
                        </p>
                        <p>
                          During the fingerprinting process, the audio or video (A/V) file is analysed using 96 different parameters. The information is collected in a small file called a “fingerprint”. Some of these parameters relate directly to a musical value (e.g. BPM or key) , others are exclusively mathematical in nature. The signal itself is not changed ( -{'>'} passive processing). With software developed by Cugate we can now do two things:
                        </p>
                        <ul>
                          <li>
                            1. match an A/V file against a database of fingerprints and identify them,
                          </li>
                          <li>
                            2. compare the properties of the files to filter out similarities or certain relationships.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="uk-panel">
                      <h2 className="uk-h1 uk-text-primary">
                        Watermark
                      </h2>
                      <div className="uk-text-small">
                        <p>
                          In a second step, called watermarking, we now actively change the properties of the file itself. A certain code is converted into an audio signal in the psychoacoustic frequency range and written into the data itself.
                          These codes are stored in a database and can be used to trigger all kinds of actions. Our decoder can extract the codes and assign the event or action previously assigned to it.
                          We ensure that the full length of the code can be written to the file. This ensures that the codes can be read at any point in the file. For this reason, the watermark is written in variable time segments with overlaps to ensure that it can be read in all formats.
                        </p>
                        <p>

                          Our technology makes it possible to write different levels of watermarks.
                          For audio files, we currently work with four layers:
                        </p>
                        <motion.ul style={{ listStyleType: "circle", margin: 0 }}>
                          <li>1. Identification</li>
                          <li>2. Distribution channel</li>
                          <li>3. Advertising</li>
                          <li>4. ISP control</li>
                        </motion.ul>
                        <p>
                          The combination of fingerprinting process and watermarking enables 100% secure identification. Apart from this, products using only one of the two technologies are possible. In this way, the file is still identified.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : activeTab === tabList[1].key ? (
            <div className="tab-item media-tab">
              <div className="uk-container uk-container-large">
                <div className="uk-light uk-padding-large uk-padding-remove-horizontal">
                  <div className="uk-grid uk-grid-large uk-child-width-1-2@m">
                    <div className="uk-first-column">
                      <div className="uk-position-relative">
                        <motion.img alt="" src="/imgs/landing/media-1.png"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, x: -200 }, visible: { opacity: 1, x: 0 }, }}
                        />

                        <motion.img alt="" src="/imgs/landing/media-3.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 0.8, delay: 0.2 }}
                          variants={{ hidden: { opacity: 0, scale: 0.8 }, visible: { opacity: 1, scale: 1 }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/media-4.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, x: -200 }, visible: { opacity: 1, x: 0 }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/media-2.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1, delay: 0.6 }}
                          variants={{ hidden: { opacity: 0, y: 300 }, visible: { opacity: 1, y: 0 }, }}
                        />
                      </div>
                    </div>
                    <motion.div className=""
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 0.7 }}
                      variants={{ hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 }, }}
                    >
                      <div className="uk-panel uk-margin-medium-left uk-margin-remove-left@m uk-margin-medium-right">
                        <h1 className="uk-heading-medium uk-text-primary tab-title">
                          Media
                        </h1>
                        <p className="uk-margin-medium">
                          Cugate AG holds the rights to a vast catalog of music and is still producing and releasing new music.
                          The Cugate Label Group consist of four labels for physical releases
                          Cugate Classics for Classical recordings, Clásicos Latinos
                          (for music from Latin America, Kintsugi Recordings for Neoclassical music and Memo Music for everything else).
                          Apart from that we run several other labels for digital distribution only.
                        </p>
                        <p className="uk-margin-large uk-grid uk-grid-small uk-grid-row-medium" uk-grid="" uk-scrollspy="target: > *; cls: uk-animation-slide-bottom-medium; delay: 300;">

                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-cumarket.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-cureports.svg" />
                          </a>
                        </p>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          ) : activeTab === tabList[2].key ? (
            <div className="tab-item services-tab">
              <div className="uk-container uk-container-large">
                <div className="uk-light uk-padding-large uk-padding-remove-horizontal">
                  <div className="uk-grid uk-grid-large uk-child-width-1-2@m">
                    <div className="uk-first-column">
                      <div className="uk-position-relative">
                        <motion.img alt="" src="/imgs/landing/services-4.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1, delay: 0.6 }}
                          variants={{ hidden: { opacity: 0, }, visible: { opacity: 1, }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/services-3.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, x: -100 }, visible: { opacity: 1, x: 0 }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/services-2.png" className="uk-position-cover"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1, delay: 0.6 }}
                          variants={{ hidden: { opacity: 0, }, visible: { opacity: 1, }, }}
                        />
                        <motion.img alt="" src="/imgs/landing/services-1.png"
                          initial="hidden"
                          whileInView="visible"
                          transition={{ duration: 1 }}
                          variants={{ hidden: { opacity: 0, scale: 1.5 }, visible: { opacity: 1, scale: 1 }, }}
                        />

                      </div>
                    </div>

                    <motion.div className=""
                      initial="hidden"
                      whileInView="visible"
                      transition={{ duration: 1 }}
                      variants={{ hidden: { opacity: 0, x: 100 }, visible: { opacity: 1, x: 0 }, }}
                    >
                      <div className="uk-panel">
                        <h1 className="uk-heading-medium uk-text-primary tab-title">
                          SERVICES
                        </h1>
                        <p className="uk-margin-medium">
                          Radio Monitoring:<br />
                          Since 2017, we have been monitoring the most important radio stations worldwide and can prove the use of musical works thanks to our fingerprint technology. Our system calculates the royalties that collecting societies have to pay to artists in real time (currently only for Germany). By creating station profiles, we collect valuable data for marketing purposes.
                        </p>
                        <p className="uk-margin-medium">
                          CuSync:<br />
                          Licensing music for films and advertising has become a very important source of revenue for musicians and publishers. With our CuSync system, we can now offer all interested parties access to this exclusive market.
                        </p>
                        <p className="uk-margin-medium">
                          Playlists:<br />
                          CUGATE AG is offering a multitude of copyright-free Video and Steaming channels for shops and businesses. Try our services for free and <a href="mailto:playlists@cugate.com">get in touch with us</a> for more details!
                        </p>
                        <p className="uk-margin-medium">
                          CuRadio:<br />
                          The most advanced online radio platform on the planet! We are still in our BETA phase and you might encounter a bug or two from time to time.
                        </p>
                        <p className="uk-margin-large uk-grid uk-grid-small uk-grid-row-medium" uk-grid="" uk-scrollspy="target: > *; cls: uk-animation-slide-bottom-medium; delay: 300;">

                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-cuview.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-curadio.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin  uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-cutrack.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin  uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-playlist.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-dashboard.svg" />
                          </a>
                          <a href="#" className="uk-link-reset uk-grid-margin uk-scrollspy-inview ">
                            <motion.img alt="" src="/imgs/buttons/button-cusynk.svg" />
                          </a>
                        </p>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          ) : <></>}
        </div>
      </section>

    </div>
  );
};